import { createFilterOptions } from '@mui/material';

export type SkuOption = {
  label: string;
  value: string;
  key: string;
  name?: string;
  isGeneric: boolean;
};

export const getSkuDisplayLabel = (sku: Pick<SkuOption, 'name' | 'label' | 'key'>): string =>
  String(sku.name ?? sku.label ?? '').trim() || String(sku.key ?? '');

export const normalizeSkuFieldValue = (value: unknown): string => {
  if (typeof value === 'string') return value;
  if (value && typeof value === 'object') {
    const sku = value as { key?: string; value?: string; label?: string };
    return (sku.key ?? sku.value ?? sku.label ?? '').trim();
  }
  return '';
};

export const toInputString = (value: unknown): string => {
  if (typeof value === 'string') return value;
  if (value == null) return '';
  if (typeof value === 'object') {
    const normalized = normalizeSkuFieldValue(value);
    if (normalized) return normalized;
    const sku = value as SkuOption;
    if ('key' in sku || 'name' in sku || 'label' in sku) return getSkuDisplayLabel(sku);
  }
  return String(value);
};

export const toSkuOptions = (
  skus: Array<{ key: string; name?: string | null; isGeneric?: boolean | null }>,
): SkuOption[] =>
  [...skus]
    .map((sku) => ({
      label: getSkuDisplayLabel({ key: sku.key, name: sku.name ?? undefined, label: sku.name ?? '' }),
      value: sku.key,
      key: sku.key,
      name: sku.name ?? undefined,
      isGeneric: sku.isGeneric ?? false,
    }))
    .sort((a, b) => getSkuDisplayLabel(a).localeCompare(getSkuDisplayLabel(b)));

/** Match Auto Vending / AutocompleteInput: search by name and key. */
export const filterSkuOptions = createFilterOptions<SkuOption>({
  stringify: (option) => `${getSkuDisplayLabel(option)} ${String(option.key ?? '')}`,
});
